export enum ActionType {
  RESET = "reset",
  MOVE = "move",
  UNDO = "undo",
  DISMISS = "dismiss",
}
